export enum ReasonScope {
    ToolIssue = 0,
    TicketOnHold = 1
}

export class Reason {

    public id: number;
    public name: string;
    public inUse: boolean;
    public scope: ReasonScope;

    constructor(reason: any = {}) {
        this.id = reason.id || 0;
        this.name = reason.name || '';
        this.inUse = reason.inUse;
        this.scope = reason.scope ?? ReasonScope.ToolIssue;
    }
}
